import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GetData from "../../../services/getData";
import { Col, Container, Row, Table } from "react-bootstrap";
import { getGroupTypeLabel } from "../../../i18n/groupTypes";
import "./patientPayment.css";

function PatientPayments() {
  const { t } = useTranslation("patient");
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { patientId } = useParams();
  const id_patient = Number(patientId);

  const fetchTransaction = async (id_patient) => {
    setLoading(true);
    try {
      const data = await GetData({
        module: "patient",
        block: "payments_list",
        id_patient: id_patient,
      });

      console.log("data: ", data);

      setTransactions(data.result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransaction(id_patient);
  }, [id_patient]);

  console.log("transactions: ", transactions);

  const sortedTransactions = [...transactions].sort((a, b) => {
    const aTime = Date.parse(a?.created_at);
    const bTime = Date.parse(b?.created_at);
    if (Number.isNaN(aTime) && Number.isNaN(bTime)) return 0;
    if (Number.isNaN(aTime)) return 1;
    if (Number.isNaN(bTime)) return -1;
    return bTime - aTime;
  });

  return (
    <div className="patient-payments">
      <div className=" table-list">
        {error ? (
          <div className="text-danger">{t("error", { ns: "common", message: error })}</div>
        ) : loading ? (
          <div>{t("state.loading", { ns: "common" })}</div>
        ) : transactions.length === 0 ? (
          <div className="no-patients">{t("payments.notFound")}</div>
        ) : (
          <Table className="main-table-list rounded-table">
            <thead>
              <tr>
                <th>{t("payments.colDate")}</th>
                <th>{t("payments.colClinic")}</th>
                <th>{t("payments.colGroup")}</th>
                <th>{t("payments.colMethod")}</th>
                <th>{t("payments.colStatus")}</th>
                <th>{t("payments.colAmount")}</th>
              </tr>
            </thead>
            <tbody>
              {sortedTransactions.map((item) => {
                const id = item?.id?.value || item?.id;
                if (!id) return null;

                return (
                  <tr key={id}>
                    <td>{item?.created_at || "—"}</td>
                    <td className="text-truncate">
                      {item?.name_clinic || "—"}
                    </td>
                    <td>{getGroupTypeLabel(t, { name: item?.group }) || "—"}</td>
                    <td>{item?.payment_method || "—"}</td>
                    <td>
                      <span
                        className={`status-badge ${
                          item?.status === "Оплачено"
                            ? "status-active"
                            : item?.status === "Ожидает подтверждения"
                              ? "status-limited"
                              : "status-inactive"
                        }`}>
                        {" "}
                        {item?.status}
                      </span>
                    </td>
                    <td>{item?.amount || "—"}</td>
                  </tr>
                );
              })}
              <tr className="table-summary">
                <td colSpan={6} className="summary-cell">
                  {t("payments.found", { count: transactions.length })}
                </td>
              </tr>
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
}

export default PatientPayments;
